import { useState } from "react";
import { ArrowBigUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toggleVote } from "@/hooks/useStore";
import { useApp } from "@/App";
import { cn } from "@/lib/utils";

interface VoteButtonProps {
	targetId: string;
	targetType: "roast" | "comment" | "rewrite";
	initialCount: number;
	size?: "sm" | "default";
}

export function VoteButton({ targetId, targetType, initialCount, size = "default" }: VoteButtonProps) {
	const { currentUser, showLogin } = useApp();
	const [count, setCount] = useState(initialCount);
	const [voted, setVoted] = useState(false);
	const [animating, setAnimating] = useState(false);

	const handleVote = async () => {
		if (!currentUser) {
			showLogin();
			return;
		}
		setAnimating(true);
		const isVoted = await toggleVote(currentUser.id, targetId, targetType);
		setVoted(isVoted);
		setCount((c) => (isVoted ? c + 1 : c - 1));
		setTimeout(() => setAnimating(false), 300);
	};

	return (
		<Button
			variant="ghost"
			size={size === "sm" ? "sm" : "default"}
			onClick={handleVote}
			className={cn(
				"gap-1 transition-all",
				voted && "text-orange-500 hover:text-orange-400",
				animating && "scale-110"
			)}
		>
			<ArrowBigUp
				className={cn(
					"h-5 w-5 transition-all",
					voted && "fill-orange-500",
					size === "sm" && "h-4 w-4"
				)}
			/>
			<span className="text-sm font-medium">{count}</span>
		</Button>
	);
}
